exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/_core-js@2.5.3@core-js/library/modules/_wks-ext.js
// module id = 105
// module chunks = 0